<template>
  <div class="advantage-addition-wrapper">
    <div class="advantage-addition">
      <img src="/static/img/icons/delete.svg" class="delete-icon" 
        @click="deleteInvestorPagePotentialUser(userObject.id)"
      />

      <b-field>
        <b-input placeholder="Заголовок" v-model="userObject.title"
          @change="updateInvestorPagePotentialUser(userObject)"
        ></b-input>
      </b-field>

      <b-field>
        <Editor v-model="text" :editorToolbar="customToolbar" v-bind:id="`e${userObject.id}`"/>
      </b-field>

      <b-field>
        <b-input placeholder="Кнопка 'читать подробнее'" v-model="userObject.learnMoreTitle"
          @change="updateInvestorPagePotentialUser(userObject)"
        ></b-input>
      </b-field>

      <b-field>
        <b-input placeholder="Ссылка" v-model="userObject.learnMoreLink"
          @change="updateInvestorPagePotentialUser(userObject)"
        ></b-input>
      </b-field>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { VueEditor as Editor } from 'vue2-editor'
  import deepcopy from 'deepcopy'

  export default {
    name: 'PotentialUser',
    data () {
      return {
        text: '',
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
          ['link']
        ]
      }
    },

    computed: {
      userObject () {
        if (this.potentialUser) {
          this.text = this.potentialUser.lead
          return deepcopy(this.potentialUser)
        }
      }
    },

    props: {
      potentialUser: {
        type: Object,
        required: true
      }
    },

    methods: {
      ...mapActions(['deleteInvestorPagePotentialUser', 'updateInvestorPagePotentialUser'])
    },

    watch: {
      text () {
        this.userObject.lead = this.text
        this.updateInvestorPagePotentialUser(this.userObject)
      }
    },

    components: { Editor }
  }
</script>

<style>
.advantage-addition-wrapper {
  background: #eeeeee;
  padding: 30px;
  margin: 20px 0px;
}

.advantage-addition, .service-description {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
}

.delete-icon {
  width: 24px;
  position: absolute;
  top: -20px;
  right: -20px;
  z-index: 100;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PotentialUser.vue?aa463032